import React from "react";
import i18n from "i18n";
import styles from "./ItemTags.module.scss";
import Item from "../Item";


const ItemTags = ({
  step,
  item,
  type,
  quantity,
  expected,
  allSelecteds,
  handleDelete,
  handleSelect,
  reprint = false,
}) => {
  return (
    <div className={styles["item-tag-container"]}>
      <div className={styles["item-tags-item"]}>
        <Item
          step={step}
          title={item.title}
          sku={item.sku}
          tagsQuantity={quantity}
          expectedUnits={expected}
          image={item.item_files?.[0]?.file_name}
          batch={item.tags?.[0]?.batch}
          expiration_date={item.tags?.[0]?.expiration_date}
          tags={item.tags}
          allSelecteds={allSelecteds}
          handleSelect={handleSelect}
          type={type}
          reprint={reprint}
        />
      </div>
    </div>
  );
};

export default ItemTags;